module.exports = __webpack_public_path__ + "img/maintain-icon1.467ab981.png";